import React, { useEffect, useRef, useState } from 'react'

function RemoteSvgWithJS({
  id = '',
  url = '',
  classNames = '',
  svgContent = '',
  title = '',
}) {
  const iframeRef = useRef(null)

  useEffect(() => {
    function handleMessage(event) {
      if (
        event.data &&
        event.data.svgHeight &&
        iframeRef.current &&
        url === event.data.url &&
        id === event.data.id
      ) {
        iframeRef.current.style.height = event.data.svgHeight + 'px'
        iframeRef.current.style.width = event.data.svgWidth + 'px'
      }
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  useEffect(() => {
    if (!svgContent || !iframeRef.current) return

    const node = iframeRef.current
    let observer = null

    if (node) {
      observer = new window.IntersectionObserver(
        ([entry]) => {
          const target = entry.target
          if (entry.isIntersecting) {
            if (target) {
              target.contentWindow.postMessage({ action: 'reload' }, '*')
            }
          }
        },
        { threshold: 0.2 }
      )

      observer.observe(node)
    }

    return () => {
      if (observer) {
        observer.disconnect()
      }
    }
  }, [svgContent])

  const nonce = window?.digitalData?.page?.pageInfo?.nonce || ''

  const svgContentWithNonce = nonce
    ? svgContent.replace(/<script\b/g, `<script nonce="${nonce}"`)
    : svgContent

  const iframeSrcDoc = svgContent
    ? `
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            body, html {
              margin: 0;
              padding: 0;
              overflow: hidden;
              background: transparent;
            }
            svg {
              display: block;
            }
          </style>
        </head>
        <body>
          ${svgContentWithNonce}
          <script ${nonce ? `nonce="${nonce}"` : ''}>
          function sendHeight() {
            var svg = document.querySelector('svg');
            if (svg) {
              var height = svg.getBoundingClientRect().height;
              var width = svg.getBoundingClientRect().width;
              window.parent.postMessage({ svgHeight: height, svgWidth: width, url: '${url}', id: '${id}' }, '*');
              setTimeout(() => {
                window.parent.postMessage({ svgHeight: height, svgWidth: width, url: '${url}', id: '${id}' }, '*');
              }, 2000);
            }
          }
          window.onload = sendHeight;
          window.onresize = sendHeight;
          window.addEventListener('message', (event) => {
            if (event.data.action === 'reload') {
              window.location.reload();
            }
          });
        </script>
        </body>
      </html>
    `
    : ''

  return (
    <div className={`RemoteSvgWithJS ${classNames}`} data-url={url}>
      <iframe
        id={id}
        ref={iframeRef}
        title={title || 'Remote SVG Viewer'}
        sandbox="allow-scripts"
        srcDoc={iframeSrcDoc}
        width="100%"
        style={{ border: 'none', maxWidth: '100%', height: '1px' }}
      />
    </div>
  )
}

export default RemoteSvgWithJS
